module.exports = __webpack_public_path__ + "static/media/1.1944c059.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/9020/1.jpg
// module id = 868
// module chunks = 0